import * as React from "react";
import { theme } from "../../../theme";

interface IconProps {
  color?: string;
}

export const IssuerIcon: React.FC<IconProps> = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6667 3.66667H6.33333C3.85781 3.66667 2 5.45669 2 8.00001"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33325 12.3333H9.66659C12.1421 12.3333 13.9999 10.5433 13.9999 8"
      stroke="#A9C0C2"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 2C12.3333 2 13.9999 3.22748 13.9999 3.66668C13.9999 4.10588 12.3333 5.33333 12.3333 5.33333"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66665 10.6667C3.66665 10.6667 2.00001 11.8941 2 12.3333C1.99999 12.7725 3.66667 14 3.66667 14"
      stroke="#A9C0C2"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RecipientIcon: React.FC<IconProps> = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6667 3.66667H6.33333C3.85781 3.66667 2 5.45669 2 8.00001"
      stroke="#A9C0C2"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33325 12.3333H9.66659C12.1421 12.3333 13.9999 10.5433 13.9999 8"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 2C12.3333 2 13.9999 3.22748 13.9999 3.66668C13.9999 4.10588 12.3333 5.33333 12.3333 5.33333"
      stroke="#A9C0C2"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66665 10.6667C3.66665 10.6667 2.00001 11.8941 2 12.3333C1.99999 12.7725 3.66667 14 3.66667 14"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IssuerAndRecipientIcon: React.FC<IconProps> = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6667 3.66667H6.33333C3.85781 3.66667 2 5.45669 2 8.00001"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33325 12.3333H9.66659C12.1421 12.3333 13.9999 10.5433 13.9999 8"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3333 2C12.3333 2 13.9999 3.22748 13.9999 3.66668C13.9999 4.10588 12.3333 5.33333 12.3333 5.33333"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66665 10.6667C3.66665 10.6667 2.00001 11.8941 2 12.3333C1.99999 12.7725 3.66667 14 3.66667 14"
      stroke="#0F5156"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UnknownIcon: React.FC<IconProps> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 3C10.6667 3.55229 10.219 4 9.66675 4C9.11448 4 8.66675 3.55229 8.66675 3C8.66675 2.44771 9.11448 2 9.66675 2C10.219 2 10.6667 2.44771 10.6667 3Z"
      stroke={color}
      strokeWidth="1.2"
    />
    <path
      d="M3.33325 8L4.31739 6.44952C4.4912 6.1757 4.57811 6.03878 4.69159 5.92752C4.80508 5.81626 4.94111 5.73462 5.21316 5.57134L5.82764 5.20254C6.40264 4.85744 6.69012 4.68488 7.00805 4.66802C7.32592 4.65116 7.62852 4.79241 8.23372 5.07491L9.36372 5.60239C9.61252 5.71855 9.73692 5.77662 9.84578 5.8579C9.92298 5.9155 9.99405 5.98156 10.0579 6.05498C10.148 6.15856 10.2181 6.28118 10.3581 6.52642C10.6047 6.95794 10.7279 7.17374 10.9017 7.32574C11.0244 7.433 11.1644 7.51627 11.3151 7.57154C11.5287 7.64987 11.7682 7.64987 12.2473 7.64987H12.6666"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.66659 5L5.33325 9.33333M5.33325 9.33333L6.2978 10.6837C6.69625 11.2415 6.60677 12.0107 6.09083 12.4621L4.33325 14M5.33325 9.33333H7.66659M7.66659 9.33333H8.66659C9.08625 9.33333 9.48145 9.53093 9.73325 9.86667L11.3333 12M7.66659 9.33333L9.99992 6"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CompanyIcon: React.FC<IconProps> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33325 9.33333C1.33325 6.9956 1.33325 5.82669 1.93856 5.03995C2.04937 4.89592 2.17318 4.76386 2.30821 4.64566C3.04577 4 4.1416 4 6.33325 4H9.66658C11.8583 4 12.9541 4 13.6917 4.64566C13.8267 4.76386 13.9505 4.89592 14.0613 5.03995C14.6666 5.82669 14.6666 6.9956 14.6666 9.33333C14.6666 11.6711 14.6666 12.84 14.0613 13.6267C13.9505 13.7707 13.8267 13.9028 13.6917 14.021C12.9541 14.6667 11.8583 14.6667 9.66658 14.6667H6.33325C4.1416 14.6667 3.04577 14.6667 2.30821 14.021C2.17318 13.9028 2.04937 13.7707 1.93856 13.6267C1.33325 12.84 1.33325 11.6711 1.33325 9.33333Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M10.6666 4.00001C10.6666 2.74293 10.6666 2.11439 10.2761 1.72387C9.88552 1.33334 9.25699 1.33334 7.99992 1.33334C6.74285 1.33334 6.1143 1.33334 5.72378 1.72387C5.33325 2.11439 5.33325 2.74293 5.33325 4.00001"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00008 7.33332C7.26368 7.33332 6.66675 7.78106 6.66675 8.33332C6.66675 8.88559 7.26368 9.33332 8.00008 9.33332C8.73648 9.33332 9.33341 9.78106 9.33341 10.3333C9.33341 10.8856 8.73648 11.3333 8.00008 11.3333M8.00008 7.33332C8.58061 7.33332 9.07448 7.61159 9.25755 7.99999M8.00008 7.33332V6.66666M8.00008 11.3333C7.41955 11.3333 6.92568 11.0551 6.74261 10.6667M8.00008 11.3333V12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.99992 8H1.33325"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.6667 8H12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const NoneIcon: React.FC<IconProps> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9999 3L14.6666 5.66667C14.4839 6.03211 14.0752 6.33333 13.6666 6.33333L12.6666 5.33333C12.0694 5.33333 11.5221 4.89988 11.3333 4.33333"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3334 1.33333L11.6667 1.99999C10.3334 2.33333 9.45868 3.2908 9.11075 4.33463L8.66675 5.66666C7.23215 6.6914 6.21222 6.45605 5.12579 6.12273C4.43699 5.91142 3.64884 6.0179 3.13939 6.52736C2.83676 6.83 2.66675 7.24046 2.66675 7.66839V14"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.99992 6.33333L2.50407 6.08541C2.39174 6.02924 2.26787 6 2.14227 6C1.69546 6 1.33325 6.36221 1.33325 6.809V9.33333"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6666 5L11.6017 5.09731C11.225 5.66239 11.1506 6.37673 11.4029 7.00733C11.5749 7.4376 11.6182 7.9086 11.5273 8.363C11.4031 8.98433 10.8605 9.64853 10.3333 10V14"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66675 14V9.66667"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M5.33325 10.6667C5.33325 10.6667 6.87172 11.4167 8.66659 10.6667"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66659 9.66667C5.33325 11 4.33325 11.3333 4.33325 11.3333V14.0003"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
